import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { OptionalHolidayColumns } from "../../tableColumns/table-columns";
import { OptionalHolidayJson } from "../../DynamicFormsJson/Transaction/optionalHoliday";
import { withRouter } from "../../components/withRouter";
import { compose } from "recompose";
import { getOptionalHolidays } from "../../Slice/year.slice";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { Grid, Paper } from "@mui/material";
import { ButtonCompo } from "../../components/Comman/Button";

class OptionalHolidayForSelfTable extends React.Component {
    constructor(props) {
        super(props);
    }


    clickSubmitHandler = () => {
        this.props.navigate("/optional-holiday-under-team")
    }


    render() {
        const { optionalHolidayList, getOptionalHolidays } = this.props;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <DynamicMainScreen
                        formPath={OptionalHolidayJson.formPath}
                        screenTitle={OptionalHolidayJson.screenTitle}
                        fieldMeta={OptionalHolidayJson.fieldMeta}
                        showPdfDownload={false}
                        showExcelDownload={true}
                        changeExcelURL={OptionalHolidayJson.excelUrl}
                        showExtension={false}
                        filterDataExcel={true}
                        pdfFileName={OptionalHolidayJson.pdfFileName}
                        excelFileName={OptionalHolidayJson.excelFileName}
                        showAddButton={true}
                        tableColumnsToFilter={OptionalHolidayJson.tableColumnsToFilter}
                        tableColumns={OptionalHolidayColumns}
                        tableData={optionalHolidayList?.optionalHoliday}
                        getTableData={getOptionalHolidays}
                        apiBaseURL={OptionalHolidayJson.apiBaseURL}
                        baseIdColumn={OptionalHolidayJson.baseIdColumn}
                        showDeleteIcon={false}
                        showViewButtonInTable={false}
                        formPathView={OptionalHolidayJson.formPathView}
                        showEditIcon={false}
                        isActionColActive={false}
                        addTitle={"Holiday"}
                    />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                    >
                        <ButtonCompo
                            sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                            }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Add Team Holiday"}
                            onClick={this.clickSubmitHandler}
                            fullWidth={false}
                        />
                    </Grid>
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    optionalHolidayList: state.year,
});
const mapDispatchToProps = {
    getOptionalHolidays,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OptionalHolidayForSelfTable);
